<template>
  <div class="mt-4 mb-0 jumbotron jumbotron-fluid">
    <div class="container">
      <p class="text-center">
        <strong>{{ label }}</strong>
      </p>
      <p class="text-center">
        <b-button
          variant="success"
          size="lg"
          class="d-inline-flex align-items-center"
          href="https://wa.me/+50763084298"
        >
          <span class="icon-whatsapp mr-2" /><strong>{{ btn }}</strong>
        </b-button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Una pregunta?'
    },
    btn: {
      type: String,
      default: '¡Contáctanos por Whatsapp!'
    }
  }
}
</script>
